import { Controller } from "@hotwired/stimulus"

import { overlayContainer } from "../../lib/overlayContainer"

export default class extends Controller {
  static values = { options: Object }

  connect() {
    // Spread last so markup that names its own container still wins.
    this.tooltip = new bootstrap.Tooltip(this.element, {
      container: overlayContainer(this.element),
      ...(this.hasOptionsValue ? this.optionsValue : {}),
    })
  }

  // dispose() removes the tip itself; hide() first queues a post-fade callback that
  // throws once dispose() has cleared the tooltip's state.
  disconnect() {
    this.tooltip?.dispose()
  }
}
